import React from "react";
import { Button } from "reactstrap";
import "./SideColumn.css";

class SideColumnWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  toggleDrawer() {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  render() {
    return (
      <aside
        className={
          "side-column " + (this.state.isExpanded ? "expanded" : "compact")
        }
      >
        {this.props.children}
        <Button
          outline
          className="side-column-toggle"
          onClick={this.toggleDrawer}
        >
          Expand
        </Button>
      </aside>
    );
  }
}

export default SideColumnWrapper;



// WEBPACK FOOTER //
// ./src/system/components/SideColumn/index.jsx